import { ArrowDownLightIcon, XCrossIcon } from "../../assets";

interface OrderTrackingRow {
  status: string;
  location?: string;
  zip?: string;
  date: string;
  time: string;
}

interface OrderTrackingModalProps {
  isOpen?: boolean;
  onClose: () => void;
  data?: OrderTrackingRow[];
  orderNumber?: string;
}

const COLUMNS = [
  "Order Status",
  "Status Date",
  "Status Time",
];

const OrderTrackingModal: React.FC<OrderTrackingModalProps> = ({
  isOpen = true,
  onClose,
  data = [],
  orderNumber,
}) => {
  if (!isOpen) return null;

  return (
    <div className="modal modal--orderCharge modal--orderTracking modal--open">
      <div className="modal__dialog">
        <div className="modal__content modal__content--md">
          <div className="modal__header">
            <h4 className="modal__header--title">
              {orderNumber
                ? `Order Tracking Details #${orderNumber}`
                : "Order Tracking Details"}
            </h4>

            <button
              className="btn btn__transparent btnClose"
              onClick={onClose}
            >
              <XCrossIcon />
            </button>
          </div>

          <div className="modal__body modal-body-left">
            <div className="formRow">
              <div className="tableWrapCard">
                <div className="tableWrap">
                  <div
                    className="tableContainer"
                    style={{ maxHeight: "400px", overflowY: "auto" }}
                  >
                    <table className="table">
                      <thead
                        style={{
                          position: "sticky",
                          top: 0,
                          zIndex: 1,
                          background: "#fff",
                        }}
                      >
                        <tr>
                          {COLUMNS.map((col) => (
                            <th key={col}>
                              <div className="sortingDiv">
                                {col}
                              </div>
                            </th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {data.length > 0 ? (
                          data.map((row, index) => (
                            <tr key={`${row.status}-${row.date}-${row.time}-${index}`}>
                              <td>
                                <div className="cellText">
                                  <span className="cellText__dark">
                                    {row.status || "-"}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="cellText">
                                  <span className="cellText__dark">
                                    {row.date || "-"}
                                  </span>
                                </div>
                              </td>
                              <td>
                                <div className="cellText">
                                  <span className="cellText__dark">
                                    {row.time || "-"}
                                  </span>
                                </div>
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={COLUMNS.length}
                              style={{ textAlign: "center" }}
                            >
                              No status data available
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};

export default OrderTrackingModal;
